// Workspace.blockedModels is stored as a JSON-encoded array (AWSJSON) of
// registry model ids; forms work with the parsed array (AppFormMultiSelect).
// The multi-select stores full option objects in Formik, so:
//  - normalizeBlockedModels: coerces any stored shape (plain ids OR legacy
//    full option objects) into minimal {id, name, value} options the
//    multi-select can render as chips.
//  - blockedModelsToIds: extracts the plain model ids for persistence
//    (JSON string) and backend consumption.
export const parseBlockedModels = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string" && raw) {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }
  return [];
};

export const blockedModelsToIds = (blockedModels) => {
  return parseBlockedModels(blockedModels)
    .map((m) => {
      if (typeof m === "string") return m;
      if (m && typeof m === "object") return m.id || m.value || null;
      return null;
    })
    .filter((m) => !!m);
};

export const normalizeBlockedModels = (raw, options = []) => {
  // Map stored ids onto the picker's option objects (friendly name +
  // backgroundColor) so chips render labelled + coloured like the dropdown.
  // Falls back to the bare id when the model isn't in the current option list.
  return blockedModelsToIds(raw).map((id) => {
    const match = options.find((o) => o?.id === id || o?.value === id);
    return match || { id, value: id, name: id, label: id };
  });
};

export const getBlockedModelIds = (workspace) => {
  return blockedModelsToIds(workspace?.blockedModels);
};
